var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExclaimation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2,
    height: 14,
    viewBox: "0 0 2 14",
    fill: "none",
    stroke: "#FC0A54",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1V7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 13H1.02"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclaimation);
export default __webpack_public_path__ + "static/media/exclaimation.73ef925086ac736cd7fd334dafe30c37.svg";
export { ForwardRef as ReactComponent };